import { render, staticRenderFns } from "./OnInitModal.vue?vue&type=template&id=265c9d80&scoped=true&"
import script from "./OnInitModal.vue?vue&type=script&lang=js&"
export * from "./OnInitModal.vue?vue&type=script&lang=js&"
import style0 from "./OnInitModal.vue?vue&type=style&index=0&id=265c9d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c9d80",
  null
  
)

export default component.exports